module.exports = __webpack_public_path__ + "img/it-business-continuity2x.c2aecc8c.png";